import { findElementByIdInShadowDom } from './utils/render.js';

import { renderShapesMap } from './shapesMap.js';

const mapElement = findElementByIdInShadowDom('map');

async function main() {
  renderShapesMap(mapElement);
}

main().catch(console.error);
